import { useParams, useLocation } from "react-router-dom";
import { useGetFPOByIdQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { setBreadcrumbs } from "app/appSlice";
import { useDispatch } from "react-redux";
import ProjectProfileDashboardById from "./ProjectProfileDashboardById";
import  ProjectNewCustomUiDesign  from "./ProjectNewCustomUiDesign";

import { TabPanel } from "features/Procurement/common/TabPanel";
const ProjectFpoDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const project = location.pathname.includes("project");
  const activeCards = location.state?.cards || [];
  const activeProjects = location.state?.projectExist || [];
    const orgAdmin = location.state?.orgAdmin || "";

  
  // console.log("telling", activeProjects);
  const [FPO, setFPO] = useState({
    id: "",
    created_at: "",
    organization_name: "",
    coi_number: "",
    implementation_agency: "",
    land_holding: "",
    income: "",
    cbbo_deals: "",
    upcomming_estimated_value: "",
    email: "",
    phone_number: "",
    state_name: "",
    district_name: "",
    block_name: "",
    pincode: "",
    address: "",
    location: "",
  });

  const {
    data: data,
  } = useGetFPOByIdQuery(id);

  useEffect(() => {
    const userFromApi = data?.data ? data?.data : FPO;
    setFPO(userFromApi);
  }, [data]);

  const dispatch = useDispatch();
  useEffect(() => {
    const breadcrumbs = [
      { name: "Dashboard", link: "/dashboard" },
      { name: "Onboarding", link: "/onboarding" },
      { name: "FPO", link: "/onboarding/farmers-group/FPO" },
      {
        name: FPO.organization_name,
        link: `/onboarding/organizations/FPO/${FPO.organization_name}`,
      },
    ];

    dispatch(setBreadcrumbs(breadcrumbs));
  }, [FPO]);
  return (
    <div style={{ marginTop: "-1%", marginBottom: "1.5rem" }}>
      <div
        style={{
          background: project ? "" : "#f5f5f5",
          padding: "0.5rem",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: project ? "" : "0px 2px 8px rgba(0,0,0,0.05)",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
         {!activeProjects?.showCustomUiDesign&& <img
            src={
              location.pathname.includes("CBBO")
                ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkFOJ8hdGU33MV-oiLe_ZJlRZ1b-7i_v9qKA&s"
                : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGG4qsd0IegUHszoq04ev5AhFA8uLER3Fkng&s"
            }
            alt="Dashboard Icon"
            style={{ width: "40px", height: "40px", objectFit: "contain" }}
          />
}
          <div className={activeProjects?.showCustomUiDesign?"mx-4":""}>
            <h4
              style={{
                margin: 0,
                fontWeight: 700,
                color: "#333",
                fontSize: "1.8rem",
              }}
            >
              {location.pathname.includes("CBBO")
                ? "CBBO Dashboard"
                : `${FPO.organization_name}`}
            </h4>
            {!activeProjects?.showCustomUiDesign&& <p style={{ margin: 0, color: "#666", fontSize: "0.95rem" }}>
              Overview and insights for{" "}
              {location.pathname.includes("CBBO")
                ? "Cluster-Based Business Organization (CBBO)"
                : "Farmer Producer Organization (FPO)"}
            </p>}
          </div>
        </div>
      </div>
     {activeProjects?.showCustomUiDesign?
      <ProjectNewCustomUiDesign activeCards={activeCards}
          activeProjects={activeProjects} orgName={FPO.organization_name} orgAdmin={orgAdmin}/>
      :<div className="mt-4">
        <ProjectProfileDashboardById
          activeCards={activeCards}
          activeProjects={activeProjects}
        />
      </div>
}
    </div>
  );
};

export default ProjectFpoDetails;
